const AUTH_TOKEN_KEY = "auth_token";

export const getAuthToken = () => {
  return window.sessionStorage.getItem(AUTH_TOKEN_KEY);
};

export const setAuthToken = (token: string) => {
  window.sessionStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearAuthToken = () => {
  window.sessionStorage.removeItem(AUTH_TOKEN_KEY);
};

export { AUTH_TOKEN_KEY };
